import { Modal } from 'antd';
import React from 'react';

export const ModalTheme = (props) => {
  const { open, title, onToggle, children, width } = props;
  return (
    <Modal
      title={title || 'Basic Modal'}
      open={open}
      onOk={onToggle}
      onCancel={onToggle}
      maskClosable={false}
      destroyOnClose={true}
      footer={null}
      width={width}
    >
      {children}
    </Modal>
  );
};
